import type { IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { StyledIconButton } from '../../Button/Button.styled';

export type ChatActionButtonProps = {
  label: string;
  clickedLabel?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  Icon: React.ElementType;
  iconColor?: IconButtonProps['color'];
  disabled?: boolean;
};

export function ChatActionButton({
  label,
  clickedLabel,
  onClick,
  Icon,
  iconColor = 'default',
  disabled = false,
}: ChatActionButtonProps) {
  const [tooltipText, setTooltipText] = useState(label);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setTooltipText(clickedLabel ?? label);
    onClick(event);
  };

  const onMouseLeave = () => {
    setTimeout(() => setTooltipText(label), 200);
  };

  return (
    <Tooltip title={tooltipText} placement="top">
      <StyledIconButton
        key={label}
        size="small"
        onClick={handleClick}
        onMouseLeave={onMouseLeave}
        aria-label={label}
        color={iconColor}
        disabled={disabled}
      >
        <Icon />
      </StyledIconButton>
    </Tooltip>
  );
}
